<template>
  <div class="staff" :id="'staff' + uuid"></div>
</template>

<script>
import Vex from 'vexflow'

export default {
  name: 'Staff',
  props: {
    notes: {
      default: []
    },
    uuid: {
      default: undefined
    },
    config: {
      default: {}
    }
  },
  data () {
    return {
      vf: undefined
    }
  },
  setup () {
    return {
      Vex: Vex
    }
  },
  mounted () {
    // const div = document.querySelector('#staff' + this.uuid)
    // const renderer = new Vex.Flow.Renderer(div, Vex.Flow.Renderer.Backends.SVG)
    // renderer.resize(153, 150)
    // const context = renderer.getContext()
    const vf = new Vex.Flow.Factory({ renderer: { elementId: 'staff' + this.uuid } })
    const context = vf.getContext()
    context.setViewBox(0, 0, 150, 150)
    const score = vf.EasyScore()
    const system = vf.System()
    let notes = this.notes.join(' ')
    notes = '(' + notes + ')'
    console.log('notes:', notes)
    const voices = [score.voice(score.notes(notes.replace(/x/g, '##') + '/w'))]
    system.addStave({
      voices: voices,
      options: {
        x: 0,
        y: 0,
        width: 60
      }
    }).addClef('treble')
    //
    vf.draw()
  }
}
</script>

<style scoped>
.staff {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  width: 150px;
  height: 150px;
  background: #ffffffa0;
  box-shadow: #ccc 2px 2px 5px;
  border-radius: 5px;
  transform: translate(10%);
  transition: all 0.06s ease-in-out;
}

</style>
